import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  cropTitle: 'Add a start and end for video',
  startTime: 'Start',
  endTime: 'End',
  seekToTimestamp: 'Seek to time (HH:MM:SS.MS)',
  cancel: 'Cancel',
  save: 'Save',
  overlayTitle: 'Overlay settings',
  addOverlay: 'Add overlay',
  overlayError: 'Invalid overlay settings',
  nodeDestination: 'Node destination',
  lessonDestination: 'Lesson destination',
  showOverlay: 'Show overlay for learners?',
  deleteOverlay: 'Delete overlay',
};

const welsh = {
  cropTitle: 'Ychwanegwch dechrau a diwedd ar gyfer fideo',
  startTime: 'Dechrau',
  endTime: 'Diwedd',
  seekToTimestamp: 'Ceisio amser (HH:MM:SS.MS)',
  cancel: 'Canslo',
  save: 'Cadw',
  overlayTitle: 'Gosodiadau troshaen',
  addOverlay: 'Ychwanegwch troshaen',
  overlayError: 'Gosodiadau troshaen annilys',
  nodeDestination: 'Cyrchfan Nôd',
  lessonDestination: 'Cyrchfan y Wers',
  showOverlay: 'Dangos troshaen i ddysgwyr?',
  deleteOverlay: 'Dileu troshaen',
};

export const addVideoOverlayWizardText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
